import { request, METHODS } from '../axiosInstances';

export default {
  get: (params = {}) => request(METHODS.GET, `/confirmed/`, { params }),
  create: (params: Record<string, unknown>) => request(METHODS.POST, `/confirmed/`, { params }),
  update: (params: Record<string, unknown>) => request(METHODS.PUT, `/confirmed/`, { params }),
  delete: (payload: Record<string, unknown>) => request(METHODS.DELETE, `/confirmed/`, { payload }),
  action: (source: string, action: string, params: Record<string, unknown>) =>
    request(METHODS.PUT, `${source}/actions/${action}/`, { params }),
  getURL: (params = {}) => request(METHODS.GET, `/confirmed/export/`, { params }),
};
